import React from "react";
import { FaCode, FaServer, FaLink } from "react-icons/fa";
const services = [
  {
    id: 1,
    icon: <FaCode className="service-icon" />,
    title: "Web development",
    text: ` HTML, CSS (Bootstrap, Foundation), JavaScript (React, Node, Express, MongoDB) `,
  },
  {
    id: 2,
    icon: <FaServer className="service-icon" />,
    title: "Responsive Design",
    text: ` In this era,you can't go online without having a mobile responsive website. Let me take care of that for you!`,
  },
  {
    id: 3,
    icon: <FaServer className="service-icon" />,
    title: "PSD to HTML",
    text: `Do you have a nice design in photoshop or even sketch? Contact me and I'll convert them into fully responsive, nice looking websites!`,
  },
];
export default services;
